export default "/images/bg-gr.webp?013ecb452860cd9e62bb98de7e354c48";